import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyKeyIndicatorsSubtitle = styled(Typography, {
    name: 'StyKeyIndicatorsSubtitle',
})(({ theme }) => ({
    color: theme.palette.primary.main,
    variant: 'body1',
    fontWeight: '600',
}));

export default StyKeyIndicatorsSubtitle;
